import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { VisualizacaoModo } from '../../../../../common/visualizacao-modo';
import { BaseVisualizacaoService } from '../../../../../core';
import { Periodicidade } from '../../../../../shared';
import { CampanhaOptionsActions } from '../../campanha-options';
import { CampanhaFilter } from '../../filter/campanha-filter';
import { CampanhaFilterInitialization } from '../../filter/campanha-filter-initialization';
import { CampanhaFilterStorageService } from '../../filter/campanha-filter-storage.service';
import { CampanhaFilterComponent } from '../../filter/campanha-filter.component';
import { CampanhaVisualizacaoComponent } from '../../visualizacao/campanha-visualizacao.component';
import { CampanhaDashboardComponent } from '../dashboard/campanha-dashboard.component';
import { CampanhaPipelineComponent } from '../pipeline/campanha-pipeline.component';
import { CampanhaTableComponent } from '../table/campanha-table.component';

@Component({
    selector: 'sgt-campanha-view-embedded',
    templateUrl: './campanha-view-embedded.component.html',
    styleUrls: ['./campanha-view-embedded.component.less']
})
export class CampanhaViewEmbeddedComponent implements OnInit {
    /** Options visívieis das campanhas */
    readonly optionsVisibility: CampanhaOptionsActions = {
        canEdit: false,
        canVisualizar: true,
        canDelete: false,
        // Análise
        canSolicitarAnalise: false,
        canAprovarAnalise: false,
        canReprovarAnalise: false,
        // Encerramento
        canEncerrar: false,
        // Pedidos
        canLiberarPedidos: false,
    }

    // Visualização
    @ViewChild('visualizacaoComponent') visualizacaoComponent: CampanhaVisualizacaoComponent;

    /** Key storage do filter */
    @Input() filterStorageKey: string;
    /** Periodicidade da vigência das campanhas padrão para filtrar */
    @Input() filterPeriodicidadeVigenciaDefault: Periodicidade;
    /** Key storage da visualização */
    @Input() visualizacaoStorageKey: string;
    /** Modo de visualização padrão */
    @Input() visualizacaoModoDefault: VisualizacaoModo;

    // Filter
    filter = new CampanhaFilter()
    filterInitialization = new CampanhaFilterInitialization();
    @ViewChild('campanhaFilter') campanhaFilter: CampanhaFilterComponent;
    /** Se deve exibir o filtro dos representantes */
    @Input() isShowFilterRepresentantes = true;
    /** Se deve exibir o filtro do cliente */
    @Input() isShowFilterCliente = true;
    /** ID da pessoa para filtrar as campanhas */
    @Input() idPessoaFilter: number = null;

    // Table
    @ViewChild('table') table: CampanhaTableComponent;
    // Pipeline
    @ViewChild('pipeline') pipeline: CampanhaPipelineComponent;
    // Dashboard
    @ViewChild('dashboard') dashboard: CampanhaDashboardComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private campanhaFilterStorageService: CampanhaFilterStorageService) { }

    ngOnInit(): void {
        this.initFilter();
    }

    private setStorage() {
        // Visualização
        this.visualizacaoComponent.setStorage();
        // Filter
        this.campanhaFilterStorageService.set(this.filterStorageKey, this.filter);
    }

    /** Seta os filtros padrões */
    private setDefaultFilters(force = false) {
        if (!this.campanhaFilterStorageService.hasFilter(this.filterStorageKey) || force) {
            this.filter.statuses = [];

            // Setando a periodicidade da vigência padrão quando informada
            if (this.filterPeriodicidadeVigenciaDefault) {
                this.campanhaFilter?.setVigenciaAtual(this.filterPeriodicidadeVigenciaDefault);
            }
        }
    }

    private initFilter() {
        this.filter = new CampanhaFilter(this.filterPeriodicidadeVigenciaDefault);
        this.filterInitialization.initialization.subscribe(
            isInitialized => {
                if (isInitialized) {
                    this.campanhaFilterStorageService.applyFilter(this.filterStorageKey, this.filter);
                    this.setDefaultFilters();

                    setTimeout(() => {
                        this.search();
                    }, 0);
                }
            }
        );
    }

    /** Ao alterar o modo de visualização */
    onChangeModoVisualizacao() {
        setTimeout(() => {
            this.search();
        }, 0);
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        if (!this.filterInitialization.isInitialized()) {
            return;
        }
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.setDefaultFilters(true);
        setTimeout(() => this.search(), 0);
    }

    /** Seta os filtros informados nos inputs do components */
    private setInputFilters() {
        // Setando o ID da pessoa do cliente
        if (this.idPessoaFilter) {
            this.filter.idPessoa = this.idPessoaFilter;
        }
    }

    search() {
        this.setInputFilters();
        this.setStorage();

        if (this.visualizacaoComponent.isModoTable()) { // Table
            this.table.search();
        } else if (this.visualizacaoComponent.isModoPipeline()) { // Pipeline
            this.pipeline.search();
        } else if (this.visualizacaoComponent.isModoDashboard()) { // Dashboard
            this.dashboard.load();
        }
    }

    resize() {
        jQuery(window).trigger('resize');
    }
}
